import { Box } from '@mui/material'
import MiniChart from '@/components/Table/MiniChart'
import CrmStatus from '@/components/Table/CrmStatus'
import { CustomColumnGridConfig } from '../types'
import dayjs from 'dayjs'
export const CONSUMPTION_FIELD = 'consumption' as const

const columnsConfig: CustomColumnGridConfig[] = [
  {
    field: 'name',
    headerName: 'שם',
    width: 150,
    filter: {
      type: 'options',
    },
    hideable: true,
    disableAggregation: true,
    filterable: true,
    flex: 1,
  },
  {
    flex: 1,
    field: 'address',
    headerName: 'כתובת',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'search',
    },
    filterable: true,
  },
  {
    flex: 1,
    field: 'endUnitNumber',
    headerName: 'מס’ יחידת קצה',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'search',
    },
    filterable: true,
  },
  {
    flex: 1,
    field: 'dailyUsageData',
    headerName: 'ערכים אחרונים',
    renderCell: (params: any) => {
      if (params.value == null) return '-'
      return (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <MiniChart data={params.value} />
        </Box>
      )
    },
    filter: {
      type: 'aggregated',
    },
    disableAggregation: true,
    hideable: true,
  },
  {
    flex: 1,
    field: 'lastSeen',
    headerName: 'נקלט לאחרונה',
    sortComparator: (v1, v2) => {
      const parseDate = (val: string) => {
        if (!val) return 0
        const [year, month, day] = val.split('T')[0].split('-').map(Number)
        return new Date(year, month - 1, day, 0, 0, 0, 0).getTime()
      }
      return parseDate(v1) - parseDate(v2)
    },
    renderCell: (params: any) => params.value ? dayjs(params.value).format('HH:mm DD/MM/YYYY') : '-',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'search',
    },
    filterable: true,
  },
  {
    flex: 1,
    field: 'midnightValue',
    headerName: 'ערך',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'search',
    },
    filterable: true,
  },
  {
    flex: 1,
    field: 'unitType',
    headerName: 'סוג יחידה',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'search',
    },
    filterable: true,
  },
  {
    field: 'crm',
    headerName: 'CRM',
    width: 150,
    renderCell: (params: any) => {
      return params.value ? <CrmStatus value={params.value} /> : '-'
    },
    filter: {
      type: 'options',
    },
    hideable: true,
    disableAggregation: true,
    filterable: true,
    flex: 1,
  },
]

export default columnsConfig
